import "./index.less"
import Slideshow from './slider-swiper/index'
$(document).ready(function () {
  // Banner
  new Slideshow(document.querySelector('.slide-swiper-container'), {
    autoplay: $(".slide-swiper .slide-swiper-container").attr("data-autoplay") === "true" ? true : false,
    speed: Number($(".slide-swiper .slide-swiper-container").attr("data-speed")) || 8,
  })

  $(".section-exhibition--list .exhibition--list-tabs li").click(function() {
    if($(this).hasClass("active")) return
    $(".section-exhibition--list .exhibition--list-tabs li").removeClass("active");
    $('.section-exhibition--list').css('--translate-filters-slider', `${$(this).index() * 100}%`)
    $(this).toggleClass("active")

    // 隐藏全部
    $("jky-pagination-content").each(function() {
      $(this).hide()
    })

    const cate = $(this).attr("data-cate");
    $(`jky-pagination-content[cate=${cate}]`).removeClass('hide').fadeIn('slow', function() {
      $(this).find("jky-exhibition-item").each(function() {
        $(this)[0].initTextMore()
      })
    });
  })

  // 横向平滑地滚动内容
  function scrollContentXSmoothly(item, parent, animate) {
    parent = parent || item.parentElement

    // 缓动函数,用于计算当前滚动位置
    if (!animate) {
      animate = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }
    }

    // 设置滑动时间为 300 毫秒
    const duration = 300;
    // 获取父容器当前的滚动位置
    const startScrollLeft = parent.scrollLeft;

    const scrollLeft = item.offsetLeft + (item.offsetWidth / 2) - (parent.offsetWidth / 2);
    const targetScrollLeft = scrollLeft - startScrollLeft

    // 记录动画开始时间
    let startTime = null;

    // 处理横向滚动
    const smoothScroll = (currentTime) => {
      // 如果是第一次执行,记录开始时间
      if (!startTime) {
        startTime = currentTime;
      }

      // 计算已经经过的时间
      const elapsedTime = currentTime - startTime;
      // 计算当前滚动位置
      const scrollLeft = animate(elapsedTime, startScrollLeft, targetScrollLeft, duration);
      // 设置新的滚动位置
      parent.scrollLeft = scrollLeft;

      // 如果滚动未完成,继续下一帧动画
      if (elapsedTime < duration) {
        requestAnimationFrame(smoothScroll);
      }
    }

    requestAnimationFrame(smoothScroll);
  }


  // 初始化 wrap 容器样式
  const exhibitionAnchorWrap = this.querySelector('.exhibition-list-anchor-wrap')
  if (exhibitionAnchorWrap) {
    if (exhibitionAnchorWrap.scrollWidth > exhibitionAnchorWrap.offsetWidth) {
      exhibitionAnchorWrap.style.justifyContent = 'flex-start'
    } else {
      exhibitionAnchorWrap.style.justifyContent = 'center'
    }
    
    // 锚点定位
    if ($('.exhibition-list-anchor-wrap .anchor-item').length > 0) {
      $('.exhibition-list-anchor-wrap .anchor-item').each(function () {
        $(this).off('click').on('click', function () {
          // 处理横向滚动
          scrollContentXSmoothly($(this).get(0), exhibitionAnchorWrap)
          
          $(this).siblings().removeClass('active')
          $(this).addClass('active')
          const id = $(this).attr('data-id')
          const target = $('.exhibition-list-section-wrap').find(`[data-anchor="${id}"]`)
          window.scrollTo({
            top: target?.offset().top - $('.exhibition-list-anchor-wrap').height() || 0,
            behavior: 'smooth'
          })
        })
      })
    }
  }

  // 时间线
  if (!customElements.get('jky-exhibition-timeline')) {
    customElements.define('jky-exhibition-timeline', class JkyExhibitionTimeline extends HTMLElement {
      constructor() {
        super()

        // 初始化 wrap 容器样式
        const wrapDOM = this.querySelector('.exhibition-list-timeline-wrap')
        if (wrapDOM.scrollWidth > wrapDOM.offsetWidth) {
          wrapDOM.style.justifyContent = 'flex-start'
        } else {
          wrapDOM.style.justifyContent = 'center'
        }

        this.init(wrapDOM)
      }
      init(wrapDOM) {
        const _this = this
        // 时间线
        $(wrapDOM).find('li').each(function() {
          $(this).off('click').on('click', function () {
            if ($(this).hasClass("active")) return
            // 处理横向滚动
            scrollContentXSmoothly($(this).get(0), wrapDOM)

            $(this).addClass('active')
            $(this).siblings().removeClass('active')

            // 隐藏全部
            $("jky-pagination-content").each(function() {
              $(this).hide()
            })

            const year = $(this).attr('data-year')
            // 获取当前时间年份
            const current_year = new Date().getUTCFullYear()
            if (year == current_year) {
              $('.exhibition--list-tabs-container').removeClass('hide')
              $(".section-exhibition--list .exhibition--list-tabs li[data-cate='upcoming']").trigger('click')
              $(`jky-pagination-content[cate="upcoming"]`).removeClass('hide').fadeIn('slow', function () {
                $("jky-pagination-content jky-exhibition-item").each(function () {
                  $(this)[0].initTextMore()
                })
              })
            } else {
              $('.exhibition--list-tabs-container').addClass('hide')
              $(`jky-pagination-content[cate="all"] jky-exhibition-item`).each(function () {
                $(this).removeClass("hide").css('display', 'none').fadeOut()
              })
              $(`jky-pagination-content[cate="all"]`).removeClass('hide').fadeIn()
              $(`jky-pagination-content[cate="all"] jky-exhibition-item[year="${year}"]`).each(function (index, element) {
                $(element).css('display', 'flex').fadeIn()
                if (index % 2) {
                  $(element).addClass('row-reverse')
                }
                $(this)[0].initTextMore()
              })
            }
          })
        })
      }
    })
  }


  // exhibition item
  if (!customElements.get('jky-exhibition-item')) {
    customElements.define('jky-exhibition-item', class JkyExhibitionItem extends HTMLElement {
      constructor() {
        super()

        this.init()
      }
      init() {
        const that = this
        const swiper = this.querySelector(".swiper")
        if (swiper?.querySelectorAll(".swiper-slide")?.length > 1) {
          $(this.querySelectorAll(".swiper-navigation-button")).show();
          const prev = this.querySelector(".swiper-navigation-button.prev")
          const next = this.querySelector(".swiper-navigation-button.next")
          const pagination = this.querySelector(".swiper-pagination")
          var ex_swiper = new Swiper(swiper, {
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            pagination: {
              el: pagination
            },
            spaceBetween: 20
          });

        } else {
          $(this.querySelectorAll(".swiper-navigation-button")).hide();
        }

        setTimeout(() => {
          this.initTextMore()
        }, 20);

        $(this).find('.z-button-middle)').click(function (e) {
          e.preventDefault()

          const link_type = $(this).attr("data-type") === "true"
          if (link_type) {
            window.location.hash = $(this).attr("href").replace("#", "");
            const hash = location.hash.replace("#", "");
            const list_tab = $(`.form_tab-item[id=${hash}]`)[0]

            if (list_tab) {
              const _t_h = $(".form-tabs .section-title").outerHeight() || 0
              const _icon_h = $(".form-tabs .form_tab_img").outerHeight() || 0
              const _header_h = $("header").outerHeight() || 0
              that.scrollToTop(list_tab, _t_h + _icon_h + _header_h + 30);
            }
          } else {
            window.location.href = $(this).attr("href")
          }
        })
      }

      scrollToTop(element, distance = 150) {
        if (!element) return;
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition = rect.top + scrollTop - distance;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }

      initTextMore() {
        const m_media = window.matchMedia('(max-width: 1024px)').matches
        const line_num = m_media ? 4 : 3

        $(this).find(".exhibition-detail").each(function () {
          const lineHeight = parseInt($(this).find(".text-overflow-3").css("line-height").replace("px", ""));

          const height = parseInt($(this).find(".text-overflow-3")[0].scrollHeight);
          if ((height / lineHeight) > line_num) {
            $(this).addClass("jky-tooltip");
            $(this).find(".text-overflow-3").addClass("p-after")
            $(this).find(".text-overflow-3").css("height", `${lineHeight * line_num}px`);
            $(this).find(".jky-tooltip__inner").css("display", `block`);
          } else {
            $(this).removeClass("jky-tooltip");
            $(this).find(".jky-tooltip__inner").css("display", `none`);

            $(this).find(".text-overflow-3").removeClass("p-after");
          }
        })
      }
    })
  }

  // 分页
  if (!customElements.get('jky-pagination-content')) {
    customElements.define('jky-pagination-content', class JkyPaginationContent extends HTMLElement {
      constructor() {
        super()

        if (window.innerWidth < 1024) {
          return
        }

        this.pagination = {
          per_page: Number(this.getAttribute("per_page")) || 6, // 每页数量
          total: 0,
          _total: 0,
          current: 1,
          type: this.getAttribute("pagination-type") // total | perpage (当前页码/总页数 | 每页编号显示)
        }
        this.paginationItem = this.getAttribute("target-dom") || "jky-exhibition-item" // 分页项选择器
        const visibleItems = Array.from(this.querySelectorAll(this.paginationItem)).filter(item => getComputedStyle(item)?.display !== 'none')
        this.pagination.total = this.pagination._total = Math.ceil($(visibleItems).length / this.pagination.per_page) + 1; // 分页总数
        this.init();
      }
      init() {
        if (this.pagination.type === "perpage") {
          const that = this;
          let cntDownInterval = setInterval(adjustNumber, 500);
          $(that.querySelectorAll('.pagination .prev_page,.pagination .next_page')).hide();
          var adjustNumber = function () {
            that.pagination.total--;
            if (that.pagination.total > 0) {
              $(that.querySelectorAll('.pagination')).prepend($("<li><a>" + that.pagination.total + "</a></li>").addClass('pagi-' + that.pagination.total).data('pagi', that.pagination.total));
            } else {
              clearInterval(cntDownInterval);
              $(that.querySelectorAll(that.paginationItem)).hide().slice(0, that.pagination.per_page).show();
              $(that.querySelector('.pagi-1')).addClass('current');

              $(that.querySelectorAll(".pagination [class^=pagi-]")).on("click", function () {
                $(that.querySelector("[class^=pagi-]")).removeClass('current');
                $(this).toggleClass('current');

                var highSlice = $(this).data("pagi") * that.pagination.per_page;
                var lowSlice = highSlice - that.pagination.per_page;

                $(that.querySelectorAll(that.paginationItem)).fadeOut().slice(lowSlice, highSlice).fadeIn();
              });
            }
          }
          clearInterval(cntDownInterval);
          cntDownInterval = setInterval(adjustNumber, that.pagination.per_page);
        } else {
          if (!this.querySelector(".pagination")) return
          
          this.querySelector(".pagination .pagination_content").innerHTML = `${this.pagination.current}/${this.pagination.total - 1}`

          $(this.querySelectorAll(this.paginationItem)).hide().slice(0, this.pagination.per_page).show();
          this.updatePagination();

          this.querySelector(".pagination .prev_page").addEventListener("click", () => {
            if (this.pagination.current > 1) {
              this.pagination.current--;
              this.updatePagination();
            }
          })

          this.querySelector(".pagination .next_page").addEventListener("click", () => {
            if (this.pagination.current < this.pagination._total - 1) {
              this.pagination.current++;
              this.updatePagination();
            }
          })
        }
      }
      updatePagination() {
        this.querySelector(".pagination .prev_page").classList.remove("disabled");
        this.querySelector(".pagination .next_page").classList.remove("disabled");

        if (this.pagination.current <= 1) {
          this.pagination.current = 1;
          this.querySelector(".pagination .prev_page").classList.add("disabled");
        }

        if (this.pagination.current >= this.pagination._total - 1) {
          this.pagination.current = this.pagination._total - 1;
          this.querySelector(".pagination .next_page").classList.add("disabled");
        }

        this.querySelector(".pagination .pagination_content").innerHTML = `${this.pagination.current}/${this.pagination.total - 1}`

        this.handlePage()
      }

      handlePage() {
        const that = this
        var highSlice = this.pagination.current * this.pagination.per_page;
        var lowSlice = highSlice - this.pagination.per_page;
        $(this.querySelectorAll(this.paginationItem)).fadeOut().slice(lowSlice, highSlice).fadeIn('slow', function () {
          $(that.querySelectorAll(that.paginationItem)).each(function () {
            $(this)[0].initTextMore()
          })
        });

        const _t_h = $(".form-tabs .section-title").outerHeight() || 0
        const _icon_h = $(".form-tabs .form_tab_img").outerHeight() || 0
        $('html, body').scrollTop($(this).offset().top - $("header").height() - 30 - _t_h - _icon_h);
      }
    })
  }


  // 日期格式化工具
  function formatDate(date) {
    if (date === null) {
      return '';
    }
    return [
      date.getUTCFullYear(),
      ("0" + (date.getUTCMonth() + 1)).slice(-2),
      ("0" + date.getUTCDate()).slice(-2),
      "T",
      ("0" + date.getUTCHours()).slice(-2),
      ("0" + date.getUTCMinutes()).slice(-2),
      ("0" + date.getUTCSeconds()).slice(-2),
      "Z"
    ].join("")
  }

  // 生成ICS文件内容
  function generateICS(event) {
    return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Jackery//EN
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${Date.now()}@myapp
SUMMARY:${event.title}
DESCRIPTION:${event.description}
LOCATION:${event.location}
DTSTAMP:${formatDate(new Date())}
DTSTART:${formatDate(event.start)}
DTEND:${formatDate(event.end)}
END:VEVENT
END:VCALENDAR`.replace(/^\s+/gm, "")
  }

  // 触发文件下载
  function downloadICS(content, filename = "event.ics") {
    const blob = new Blob([content], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  // 添加日历，按钮点击
  $('[data-reminder-time-button]').each(function () {
    $(this).off('click').on('click', function () {
      const title = $(this).attr('data-calendar-title')
      const location = $(this).attr('data-calendar-location')
      const description = $(this).attr('data-calendar-description')
      const startTime = $(this).attr('data-calendar-start-time').replace(/\//g, '-')
      const endTime = $(this).attr('data-calendar-end-time').replace(/\//g, '-')

      const icsContent = generateICS({
        title: title,
        location: location,
        description: description,
        start: new Date(startTime.replace(' ', 'T')),
        end: new Date(endTime.replace(' ', 'T'))
      })
      downloadICS(icsContent)
    })
  })
})
